<div class="ikigai-layout-container">

  <!-- Contenido lateral izquierdo - Descripción -->
  <div class="ikigai-sidebar">
    <h2 class="ikigai-title">Ikigai</h2>
    <!-- <br/>   <br/>   <br/> -->
    <!-- Navegación por pestañas de Ikigai -->

    <p class="ikigai-description" *ngIf="currentStep !== 'ikigai'">
      En esta nueva etapa, tienes la oportunidad de reinventarte y vivir con propósito.
      Descubramos juntos tu Ikigai.
    </p>
    <p class="ikigai-description" *ngIf="currentStep !== 'ikigai'">
      Ingresa a cada pestaña y navega entre tu Pasión, Misión, Vocación y Profesión cuantas 
      veces sea necesario, aún así cuando haz realizado ya el test inicial. Esto te ayudará a realizar 
      una autoevaluación constante.
    </p>
    
    <div *ngIf="currentStep === 'ikigai'" class="ikigai-final-description">
      <p>¿Buscas reinventarte?</p>
      <p>Si es así, el Ikigai es una herramienta poderosa que te permite explorar y reflexionar en torno a identificar y/o reafirmar aquella actividad que mantendrá tu vida llena de significado y que, al tenerla, podrías construir un legado que contribuya con el bienestar de otros, con el propósito de trascender.</p>
      <p>Ingresa a cada pestaña y navega entre tu Pasión, Misión, Vocación y Profesión cuantas veces sea necesario. Esto te ayudará a identificar con claridad tus áreas de enfoque y prioridad personal/profesional.</p>
    </div>
  </div>

  <!-- Columna principal para título, pestañas y contenido -->
  <div class="ikigai-main-column">
    
    <!-- Fila para el título y las pestañas -->
    <div class="ikigai-header-row">
      <div class="ikigai-tabs">
        <button 
          class="ikigai-tab" 
          [ngClass]="{'active': currentStep === 'passion', 'completed': stepComplete['passion']}"
          (click)="navigateTo('passion')"
          [disabled]="isTabDisabled('passion')">
          Mi Pasión
          <span class="check-icon" *ngIf="stepComplete['passion']">✓</span>
        </button>
        <button 
          class="ikigai-tab" 
          [ngClass]="{'active': currentStep === 'mission', 'completed': stepComplete['mission']}"
          (click)="navigateTo('mission')"
          [disabled]="isTabDisabled('mission')">
          Mi Misión
          <span class="check-icon" *ngIf="stepComplete['mission']">✓</span>
        </button>
        <button 
          class="ikigai-tab" 
          [ngClass]="{'active': currentStep === 'vocation', 'completed': stepComplete['vocation']}"
          (click)="navigateTo('vocation')"
          [disabled]="isTabDisabled('vocation')">
          Mi Vocación
          <span class="check-icon" *ngIf="stepComplete['vocation']">✓</span>
        </button>
        <button 
          class="ikigai-tab" 
          [ngClass]="{'active': currentStep === 'profession', 'completed': stepComplete['profession']}"
          (click)="navigateTo('profession')"
          [disabled]="isTabDisabled('profession')">
          Mi Profesión
          <span class="check-icon" *ngIf="stepComplete['profession']">✓</span>
        </button>
        <button 
          class="ikigai-tab" 
          [ngClass]="{'active': currentStep === 'ikigai', 'completed': stepComplete['ikigai']}"
          (click)="navigateTo('ikigai')"
          [disabled]="isTabDisabled('ikigai')">
          Ikigai
          <span class="check-icon" *ngIf="stepComplete['ikigai']">✓</span>
        </button>
        <!-- <button 
          class="ikigai-tab" 
          [ngClass]="{'active': currentStep === 'ikigai'}"
          (click)="navigateTo('ikigai')"
          [disabled]="isTabDisabled('ikigai')">
          Mi Ikigai
        </button> -->
      </div>
    </div>

    <!-- Contenedor principal de contenido -->
    <div class="ikigai-content-container">

      <!-- Vista de Introducción -->
      <div *ngIf="currentStep === 'introduction'" class="ikigai-introduction-view">
        <h2>Completa tu Ikigai</h2>
        <p class="introduction-text">
          Ingresa a cada pestaña y navega entre tu Pasión, Misión, 
          Vocación y Profesión cuantas veces sea necesario, aún así 
          cuando haz realizado ya el test inicial. Esto te ayudará a 
          realizar una autoevaluación constante.
        </p>
        <button class="start-button" (click)="startIkigaiProcess()">Empezar aquí</button>
      </div>
      
      <!-- Vistas de secciones de preguntas (Pasión, Misión, Vocación, Profesión) -->
      <div *ngIf="currentStep !== 'introduction'" class="ikigai-section">
        {{currentStep}}
        <h2>{{ questions[currentStep].title }} – {{ questions[currentStep].subtitle }}</h2>
        
        <div class="ikigai-question-container">
          <p class="ikigai-question">{{ questions[currentStep].question }}</p>
          
          <div class="ikigai-answer-container">
            <textarea 
              class="ikigai-answer" 
              placeholder="Respuesta"
              [(ngModel)]="userAnswer"
              maxlength="{{ questions[currentStep].maxLength }}">
            </textarea>
            <div class="character-counter">
              {{ userAnswer ? userAnswer.length : 0 }} / {{ questions[currentStep].maxLength }} caracteres
            </div>
          </div>
          
          <div class="ikigai-navigation">
            <div class="step-counter">{{ questions[currentStep].step }}/{{ questions[currentStep].totalSteps }}</div>
            @if(currentStep!=='ikigai'){
              <button class="next-button" (click)="nextStep()"> Siguiente <span class="arrow">›</span></button>
            }@else{
              <button class="next-button" (click)="nextStep()"> Completar</button>
            }
          </div>
        </div>
      </div>

      <!-- Vista final de Ikigai -->
      <div *ngIf="currentStep === 'ikigai'" class="ikigai-summary-section">
        <!-- <h2>Tu Ikigai</h2>

        <div class="ikigai-diagram">
          <div class="ikigai-circle passion-circle">
            <div class="circle-content">
              <div class="circle-description">
                Aquí se encuentran aquellas actividades que me hacen feliz, con las que se me pasa el tiempo volando. Las que podría hacer todos los días y no me cansaría, incluso las haría sin que me pagaran.
              </div>
            </div>
          </div>
        
          <div class="ikigai-circle mission-circle">
            <div class="circle-content">
              <div class="circle-description circle-description-left">
                Aquí se encuentra todo lo que veo que más requieren las personas, organizaciones, el país y el mundo, y en lo que siento que puedo contribuir.
              </div>
            </div>
          </div>
        
          <div class="ikigai-circle profession-circle">
            <div class="circle-content">
              <div class="circle-description ">
                Aquí se encuentran aquellas actividades que realizas y por las que hoy te pagan; también aquellas que te gustaría hacer en un futuro y sean remuneradas.
              </div>
            </div>
          </div>
        
          <div class="ikigai-circle vocation-circle">
            <div class="circle-content">
              <div class="circle-description circle-description-right">
                Aquí se encuentran aquellas habilidades que tienes y eres bueno en ello. Así también en qué te gustaría ser bueno más adelante.
              </div>
            </div>
          </div>
        
          <div class="intersection intersection-passion-vocation ">Pasión</div>
          <div class="intersection intersection-passion-mission">Misión</div>
          <div class="intersection intersection-vocation-profession">Profesión</div>
          <div class="intersection intersection-mission-profession">Vocación</div>
        </div>

        <div class="ikigai-results">
          <div class="ikigai-example">
            <h3>Ejemplo:</h3>
            <p>"Amo profundamente la cultura y las expresiones artísticas, y mi talento está en comunicar y enseñar de manera clara e inspiradora. Siento que el mundo necesita más acceso a la educación y a la apreciación del arte, y creo que puedo aportar valor desde ahí. Por eso, mi Ikigai se manifiesta en crear contenido educativo sobre arte y cultura, o en colaborar como consultor con instituciones culturales que busquen acercar el arte a más personas."</p>
            
            <h3>Recomendaciones:</h3>
            <p>Plan de acción preliminar sugerido:</p>
            <ol>
              <li>Fortalecer mis habilidades y posicionarme en la creación de contenido educativo.</li>
              <li>Conectar con redes y espacios del mundo cultural y educativo.</li>
              <li>Diseñar una propuesta de valor como consultor o creador de contenido cultural.</li>
            </ol>
          </div>
        </div> -->

        <!-- Opciones adicionales -->
        <div class="other-actions" *ngIf="allStepsCompleted()">
          <button class="action-button" (click)="addObjectives()">Añade objetivos</button>
          <button class="action-button" (click)="downloadIkigai()">Descarga tu Ikigai</button>
        </div>
      </div>
    </div>
  </div>
</div> 